@if (translationService.isLangReady$ | async) {
  <router-outlet></router-outlet>
}